import { Suspense } from "react";
import LoadingElement from "@/Components/Loading/LoadingElement";
import { Provider } from "react-redux";
import {useSelector} from "react-redux";
import {selectModules} from "@/Redux/App/AppReducer";
import MainComponent from "@/Containers/MainComponent";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "@/Style/index.scss";
import { initRedux } from "@/Redux/Redux";
import * as Sentry from "@sentry/react";
import { deDE } from "@mui/x-date-pickers/locales";
import { LicenseInfo } from "@mui/x-license-pro";
import {TranslationProvider} from "@/Utils/TranslationProvider";

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY || "");

const { store, history } = initRedux();

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: "production",

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

export default function App() {
    return (
        <Suspense fallback={<LoadingElement />}>
            <LocalizationProvider
                dateAdapter={AdapterMoment}
                adapterLocale={"DE"}
                localeText={
                    deDE.components.MuiLocalizationProvider.defaultProps
                        .localeText
                }
            >
                <Provider store={store}>
                    <TranslationProvider>
                        <MainComponent />
                    </TranslationProvider>
                </Provider>
            </LocalizationProvider>

        </Suspense>
    );
}
